import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import useEstudiantesLogic from "./hooks/useEstudiantesLogic";
import EstudiantesView from "./pages/EstudiantesView.jsx";
import EstudianteDetalle from "./pages/EstudianteDetalle.jsx";

export default function Estudiantes() {
  const logic = useEstudiantesLogic();

  return (
    <Routes>
      <Route path="/" element={<EstudiantesView {...logic} />} />
      <Route path=":id/detalle" element={<EstudianteDetalle />} />
      <Route path="*" element={<Navigate to="." replace />} />
    </Routes>
  );
}
